import Footer from "../Components/Footer/Footer";
import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import DHVInterior from "../Assets/dhv_interior.jpeg";

const About = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          background: "#141414 !important",
          py: 5,
          pt: 18,
        }}
      >
        <Box
          sx={{
            color: "#fff",
            maxWidth: "1080px",
            width: "90%",
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            spacing={0}
          >
            {/* Left: Story */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  background: "#283341",
                  padding: "60px",
                  borderRadius: "0px",
                  boxShadow: {
                    xs: "none",
                    sm: "none",
                    md: "-80px -80px 1px 1px #4c4c4c",
                  },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    color: "#FFDD59",
                    mb: 2,
                    transform: "skewY(-8deg)",
                    display: "inline-block",
                    fontFamily: "Poiret One",
                    fontSize: "40px",
                  }}
                >
                  OUR STORY
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "18px",
                    fontFamily: "Abhaya Libre Georgia Times New Roman serif",
                    lineHeight: 1.8,
                    mb: 4,
                    marginTop: "4rem",
                  }}
                >
                  Our journey began with a mission to celebrate Vietnam's
                  vibrant culinary heritage and make it accessible to all.
                  <br />
                  <br />
                  At Đông Hưng Viên Bakery, we're passionate about offering rich
                  and diverse Vietnamese flavors, complemented by delicious
                  vegan alternatives for everyone to enjoy.
                  <br />
                  <br />
                  Whether you're a long-time fan of Vietnamese food or trying it
                  for the first time, we promise a culinary experience that is
                  both unique and unforgettable.
                  <br />
                  <br />
                </Typography>
                <Link to="/contact">
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: "20px",
                      borderRadius: "30px",
                      textTransform: "none",
                      backgroundColor: "#00AAE3",
                      "&:hover": {
                        backgroundColor: "#33BBE8",
                      },
                    }}
                  >
                    Contact Us
                  </Button>
                </Link>
              </Box>
            </Grid>

            {/* Right: Image */}
            <Grid item xs={12} md={6} sx={{ height: "100%" }}>
              <Box
                sx={{
                  overflow: "hidden",
                  height: "100%",
                  marginTop: { xs: 3, md: "2px" },
                  display: "flex",
                  alignItems: "stretch",
                }}
              >
                <Box
                  component="img"
                  src={DHVInterior}
                  alt="Đông Hưng Viên Bakery interior"
                  sx={{
                    width: "100%",
                    height: { xs: 300, sm: 380, md: 706 },
                    objectFit: "cover",
                    display: "block",
                    borderRadius: 0,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default About;
